define('viewmodels/secured/explorer/details/tabs/actions/Action',[], function () {

    var Action = function(i19nAction, icon, context, disableFilters, hideFilters) {
        var self = this;

        self.name = i19nAction.name;
        self.message = i19nAction.message;
        self.icon = icon;
        self.context = context;
        self.disableFilters = disableFilters || [];
        self.hideFilters = hideFilters || [];
      
        self.isHidden = ko.computed(function() {
            return _.any(self.hideFilters, function(filter) {
                return filter();
            });
        });

        self.isDisabled = ko.computed(function() {
            var isDisabled = self.context.executingActions().length;
            return isDisabled ||  _.any(self.disableFilters, function (filter) {
                return filter();
            });
        });

        //#region catch-all or default implementations. 

        // typically you would use the Action.getCommand() static method to gain default behavior and access to the actual action.

        self.command = ko.asyncCommand({
            canExecute: function (action) {
                return true;
            },
            execute: function (action, complete) {
                complete();
            }
        });

        self.isBusy = ko.computed(function () {
            return self.command.isExecuting();
        });

        //#endregion
    };

    Action.getCommand = function (action, options) {

        var canExecuteDelegate = options.canExecute || function (isExecuting) {
            return !isExecuting && !action.isDisabled();
        };
        var executeDelegate = options.execute || function (action, complete) {
            complete();
        };
        var command = ko.asyncCommand({
            canExecute: canExecuteDelegate,
            execute: executeDelegate
        });

        command.isExecuting.subscribe(function (newValue) {
            if (newValue) {
                action.context.executingActions.push(action);
            } else {
                action.context.executingActions.reject_(function (executingAction) {
                    return _.isEqual(executingAction, action);
                });
            }
        });

        action.isBusy = ko.computed(function() {
            return command.isExecuting();
        });

        return command;
    };

    return Action;
});
